<script setup lang="ts">
withDefaults(
  defineProps<{
    title?: string
    link?: string
    size?: string
    optional?: boolean
    icon?: string
    placement?: string
    iconStyle?: string
    maxWidth?: number
  }>(),
  {
    maxWidth: 350,
    size: "h-[1.15rem] w-[1.15rem]",
    iconStyle: "text-rnxblue-200",
    optional: false,
    placement: "right",
    icon: $icons.help,
  },
)
</script>

<template>
  <tippy :placement="placement" class="flex items-center" :max-width="maxWidth">
    <div class="inline-flex gap-x-2">
      <UIcon :name="icon" :class="[size, iconStyle]" />
      <span v-if="optional">Optional </span>
    </div>
    <template #content>
      <div class="flex flex-col gap-y-2">
        <h3 v-if="title" class="text-center font-medium">{{ title }}</h3>
        <div>
          <slot name="default" />
        </div>
      </div>
    </template>
  </tippy>
</template>
